import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { AuthType } from 'ha/modules/AuthLogic/types';

export enum AuthModalActionTypes {
  changeModalType = 'AUTHMODAL/CHANGE_MODAL_TYPE',
}

export const CHANGE_MODAL_TYPE = AuthModalActionTypes.changeModalType;

export const AuthModalActions = {
  changeModalType: (modalType: AuthType) =>
    createAction(CHANGE_MODAL_TYPE, { modalType }),
};
export type AuthModalActionsType = ActionsUnion<typeof AuthModalActions>;

export const { changeModalType } = AuthModalActions;
